import { faBuilding } from "@fortawesome/pro-regular-svg-icons/faBuilding";
import PropTypes from "prop-types";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Card from "reactstrap/es/Card";
import Col from "reactstrap/es/Col";
import Row from "reactstrap/es/Row";

// App
import {
  ButtonAdd,
  ContentBody,
  ContentErrors,
  ContentHeader,
  ContentHeaderButtons,
  ContentHeaderTitle,
  Error403,
} from "../../core/components";
import { ROUTE_ORGANIZATION_ADD } from "../../../constants";

// Auth
import { usePermission } from "../../auth/hooks/usePermission";

// Organization
import { gridChangeFilter, gridChangePagination, gridChangeSort, gridDelete, gridFetch } from "../actions/organization";
import { OrganizationGrid } from "../components";

const OrganizationPageList = (props) => {
  const { gridErrors } = props;
  const [hasPermission] = usePermission();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("title.organizations");
  }, []);

  // Kontrola opravneni
  if (!hasPermission("organization.view")) {
    return <Error403 />;
  }

  return (
    <Fragment>
      <ContentHeader>
        <ContentHeaderTitle icon={faBuilding} title={t("title.organizations")} />
        <ContentHeaderButtons>
          {hasPermission("organization.create") && <ButtonAdd text={t("action.add")} to={ROUTE_ORGANIZATION_ADD} />}
        </ContentHeaderButtons>
      </ContentHeader>

      <ContentErrors errors={gridErrors} />

      <ContentBody>
        <Row>
          <Col>
            <Card>
              <OrganizationGrid {...props} />
            </Card>
          </Col>
        </Row>
      </ContentBody>
    </Fragment>
  );
};

OrganizationPageList.propTypes = {
  gridChangeFilter: PropTypes.func.isRequired,
  gridChangePagination: PropTypes.func.isRequired,
  gridChangeSort: PropTypes.func.isRequired,
  gridData: PropTypes.array.isRequired,
  gridDataTotal: PropTypes.number.isRequired,
  gridDelete: PropTypes.func.isRequired,
  gridErrors: PropTypes.array.isRequired,
  gridFetch: PropTypes.func.isRequired,
  gridIsDeleting: PropTypes.bool.isRequired,
  gridIsFetching: PropTypes.bool.isRequired,
  gridPage: PropTypes.number.isRequired,
  gridPageSize: PropTypes.number.isRequired,
  gridSortField: PropTypes.string.isRequired,
  gridSortOrder: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  gridChangeFilter,
  gridChangePagination,
  gridChangeSort,
  gridDelete,
  gridFetch,
};

const mapStateToProps = (state) => ({
  gridData: state.organization.gridData,
  gridDataTotal: state.organization.gridDataTotal,
  gridErrors: state.organization.gridErrors,
  gridIsDeleting: state.organization.gridIsDeleting,
  gridIsFetching: state.organization.gridIsFetching,
  gridPage: state.organization.gridPage,
  gridPageSize: state.organization.gridPageSize,
  gridSortField: state.organization.gridSortField,
  gridSortOrder: state.organization.gridSortOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationPageList);
